import React, { useMemo } from 'react';
import TableContainer from 'Common/TableContainer';


interface Props {
    manager: any[];
    account: any[];
    sales: any[];
    transaction: any[]
}

const OrderDetails: React.FC<Props> = ({ transaction }) => {
    console.log("transaction", transaction);


    const columns = useMemo(() => [
        {
            header: "#",
            accessorFn: (_: any, index: number) => index + 1,
            enableColumnFilter: false,
        },
        {
            header: "Username",
            accessorKey: "username",
            enableColumnFilter: false,
        },
        {
            header: "Receiver Name",
            accessorKey: "receiver",
            enableColumnFilter: false,
        },
        {
            header: "Payer Name",
            accessorKey: "payer",
            enableColumnFilter: false,
        },
        {
            header: "Group",
            accessorKey: "groupName",
            enableColumnFilter: false,
        },
        // {
        //     header: "Fix Rate",
        //     accessorKey: "fixrate",
        //     enableColumnFilter: false,
        // },
        // {
        //     header: "Transfer Charge",
        //     accessorKey: "transferCharge",
        //     enableColumnFilter: false,
        // },
        // {
        //     header: "Expense",
        //     accessorKey: "expense",
        //     enableColumnFilter: false,
        // },
        // {
        //     header: "Commission",
        //     accessorKey: "commission",
        //     enableColumnFilter: false,
        // },
        // {
        //     header: "USDT",
        //     accessorKey: "usdt",
        //     enableColumnFilter: false,
        // },
        {
            header: "Amount",
            accessorKey: "amount",
            enableColumnFilter: false,
        },
        {
            header: "Delivery Time",
            accessorKey: "deliveryTime",
            enableColumnFilter: false,
            cell: (info:any) => new Date(info.getValue() as any).toLocaleString("en-US", {
                day: "2-digit", month: "short", year: "numeric", 
            }),
        }, 
    ], [transaction]);




    return (
        <div className=" col-span-9 col-start-4 ">
            <div className=" col-span-9 card">
                <div className="card-body  ">
                    <div className="grid items-center grid-cols-9 gap-3    ">
                        <div className=" col-span-5  ">
                            <h6 className="text-15">Orders From Customers </h6>
                        </div>
                        <div className=" col-span-1 col-start-10  mb-2  ">
                            <button type="button" className="btn bg-custom-500 text-white">
                                <i className="ri-download-2-line pr-1"></i> Export
                            </button>
                        </div>
                    </div>
                    <TableContainer
                        isPagination={true}
                        columns={columns}
                        data={transaction || []}
                        customPageSize={4}
                        divclassName="overflow-x-auto"
                        tableclassName="w-full whitespace-nowrap"
                        theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                        thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                        tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                        PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                    />
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;

